import React from 'react';
import { useChat } from './ChatContext';
import WinLogoWhiteForChat from '../../../src/assets/images/logo-win-white.svg'; // Your Chat Window Component
import HighmarkLogoWhiteForChat from '../../../src/assets/images/highmark.png'; // Your Chat Window Component
// import './floatingchatstyles.css'; // Add styles for positioning
import { useDispatch, useSelector } from "react-redux";
import axios from 'axios';
import { Endpoints } from "../../Global/Endpoints";

const FloatingChatButton = () => {
  const { isChatVisible, toggleChat, showChat, hideChat } = useChat();
  const isLoggedIn = useSelector((state) => state.login.isAuthenticated);
  const userInfo  = useSelector((state) => state.userData);
  const token = localStorage.getItem('AccessToken');
  const hasExpired = localStorage.getItem('sessionExpired') === 'true';
  console.log({isLoggedIn,  userInfo})

    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";

    // Function to log activity
    const logChatActivity = async () => {
      const params = {
        EmailID: userInfo?.userData?.EmailID,
        Activity: "WINChat",
        DeviceType: "PatientPortal",
      };
      
      try {
        const response = await axios.post(
          Endpoints.CallRecoderLog,
          { _Params: JSON.stringify(params) },
          {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            "Connection": "close",
            "Accept": "*/*",
            Authorization: `Bearer ${token}`,
          },
        }
      );

  if (response.data) {
    console.log("Log saved successfully:",response.data);
  
  } else {
    console.warn("Log not saved: Empty response from server.");
  }

} catch (error) {
  console.error("Error saving log:", error);
}
};
  
    // Handle chat button click
    const handleChatButtonClick = () => {
      logChatActivity(); // Save log to the endpoint
      showChat(); // Show chat window
    };
    // debugger
    console.log("chat visiblity",isLoggedIn, token, userInfo?.userData?.WINChat, hasExpired, isHighmarkPortal)
  if(!isLoggedIn || !token || userInfo?.userData?.WINChat === "N" || userInfo?.userData?.WINChat !== "Y" || hasExpired ||isHighmarkPortal) return <></>
  return (
    <>
      {/* Floating Button */}
      <div className="floating-chat-button" onClick={handleChatButtonClick}>
        

        {isHighmarkPortal ? 
         <span style={{ marginBottom: '12px' }}>Chat</span>
        :
         <>
         <img src={WinLogoWhiteForChat} alt="" className="win-chat-logo" />
          <span>Chat</span>
         </> 
        }
        
      </div>

      {/* Chat Window
      {isChatVisible && <ChatBotWindow />} */}
    </>
  );
};

export default FloatingChatButton;